// // // export default function ReviewSubmitStep({ formData, onSubmit }) {
// // //   return (
// // //     <div>
// // //       <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 mb-6">
// // //         <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">
// // //           REQUEST SUMMARY
// // //         </p>
// // //         <h3 className="text-xl font-extrabold text-gray-900 mb-5">
// // //           {formData.projectName || "Untitled Project"}
// // //         </h3>

// // //         <div className="grid sm:grid-cols-2 gap-5">
// // //           <div>
// // //             <p className="text-sm text-gray-500 mb-1">Category</p>
// // //             <p className="font-semibold text-gray-900">{formData.category || "—"}</p>
// // //           </div>
// // //           <div>
// // //             <p className="text-sm text-gray-500 mb-1">Process</p>
// // //             <p className="font-semibold text-gray-900">{formData.process || "—"}</p>
// // //           </div>
// // //           <div>
// // //             <p className="text-sm text-gray-500 mb-1">Centre</p>
// // //             <p className="font-semibold text-gray-900">
// // //               {formData.centre ? `APIC ${formData.centre}` : "—"}
// // //             </p>
// // //           </div>
// // //           <div>
// // //             <p className="text-sm text-gray-500 mb-1">Files</p>
// // //             <p className="font-semibold text-gray-900">
// // //               {formData.files.length} uploaded
// // //             </p>
// // //           </div>
// // //         </div>
// // //       </div>

// // //       <button
// // //         type="button"
// // //         onClick={onSubmit}
// // //         className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-500 text-white font-semibold py-3.5 rounded-xl hover:opacity-90 transition"
// // //       >
// // //         Submit Prototype Request →
// // //       </button>
// // //     </div>
// // //   );
// // // }



// // export default function ReviewSubmitStep({ formData, onSubmit, isSubmitting, error }) {
// //   return (
// //     <div>
// //       <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 mb-6">
// //         <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">
// //           REQUEST SUMMARY
// //         </p>
// //         <h3 className="text-xl font-extrabold text-gray-900 mb-5">
// //           {formData.projectName || "Untitled Project"}
// //         </h3>

// //         <div className="grid sm:grid-cols-2 gap-5">
// //           <div>
// //             <p className="text-sm text-gray-500 mb-1">Category</p>
// //             <p className="font-semibold text-gray-900">{formData.category || "—"}</p>
// //           </div>
// //           <div>
// //             <p className="text-sm text-gray-500 mb-1">Process</p>
// //             <p className="font-semibold text-gray-900">{formData.process || "—"}</p>
// //           </div>
// //           <div>
// //             <p className="text-sm text-gray-500 mb-1">Quantity</p>
// //             <p className="font-semibold text-gray-900">{formData.requiredQuantity || "—"}</p>
// //           </div>
// //           <div>
// //             <p className="text-sm text-gray-500 mb-1">Target Delivery</p>
// //             <p className="font-semibold text-gray-900">{formData.targetDeliveryDate || "—"}</p>
// //           </div>
// //           <div>
// //             <p className="text-sm text-gray-500 mb-1">Files</p>
// //             <p className="font-semibold text-gray-900">
// //               {formData.enquiryFiles?.length || 0} uploaded
// //             </p>
// //           </div>
// //           <div>
// //             <p className="text-sm text-gray-500 mb-1">Status</p>
// //             <p className="font-semibold text-green-600">Ready to Submit</p>
// //           </div>
// //         </div>
// //       </div>

// //       {error && (
// //         <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">
// //           {error}
// //         </div>
// //       )}

// //       <button
// //         type="button"
// //         onClick={onSubmit}
// //         disabled={isSubmitting}
// //         className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-500 text-white font-semibold py-3.5 rounded-xl hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
// //       >
// //         {isSubmitting ? (
// //           <>
// //             <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
// //               <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
// //               <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
// //             </svg>
// //             Submitting...
// //           </>
// //         ) : (
// //           "Submit Prototype Request →"
// //         )}
// //       </button>
// //     </div>
// //   );
// // }





// import { ArrowLeft } from "lucide-react";

// export default function ReviewSubmitStep({ formData, onSubmit, onBack, isSubmitting, error }) {
//   return (
//     <div>
//       <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 mb-6">
//         <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">
//           REQUEST SUMMARY
//         </p>
//         <h3 className="text-xl font-extrabold text-gray-900 mb-5">
//           {formData.projectName || "Untitled Project"}
//         </h3>

//         <div className="grid sm:grid-cols-2 gap-5">
//           <div>
//             <p className="text-sm text-gray-500 mb-1">Category</p>
//             <p className="font-semibold text-gray-900">{formData.category || "—"}</p>
//           </div>
//           <div>
//             <p className="text-sm text-gray-500 mb-1">Process</p>
//             <p className="font-semibold text-gray-900">{formData.process || "—"}</p>
//           </div>
//           <div>
//             <p className="text-sm text-gray-500 mb-1">Quantity</p>
//             <p className="font-semibold text-gray-900">{formData.requiredQuantity || "—"}</p>
//           </div>
//           <div>
//             <p className="text-sm text-gray-500 mb-1">Target Delivery</p>
//             <p className="font-semibold text-gray-900">{formData.targetDeliveryDate || "—"}</p>
//           </div>
//           <div>
//             <p className="text-sm text-gray-500 mb-1">Files</p>
//             <p className="font-semibold text-gray-900">
//               {formData.enquiryFiles?.length || 0} uploaded
//             </p>
//           </div>
//           <div>
//             <p className="text-sm text-gray-500 mb-1">Status</p>
//             <p className="font-semibold text-green-600">Ready to Submit</p>
//           </div>
//         </div>
//       </div>

//       {error && (
//         <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">
//           {error}
//         </div>
//       )}

//       <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-100">
//         <button
//           type="button"
//           onClick={onBack}
//           className="flex items-center gap-2 text-sm font-semibold px-5 py-2.5 rounded-xl border border-gray-200 text-gray-700 hover:bg-gray-50 transition"
//         >
//           <ArrowLeft className="w-4 h-4" />
//           Back to Edit
//         </button>
//         <button
//           type="button"
//           onClick={onSubmit}
//           disabled={isSubmitting}
//           className="flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-500 text-white font-semibold px-6 py-2.5 rounded-xl hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
//         >
//           {isSubmitting ? (
//             <>
//               <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                 <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                 <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//               </svg>
//               Submitting...
//             </>
//           ) : (
//             "Submit Prototype Request →"
//           )}
//         </button>
//       </div>
//     </div>
//   );
// }




import { ArrowLeft } from "lucide-react";

export default function ReviewSubmitStep({ formData, onSubmit, onBack, isSubmitting, error }) {
  // Format manufacturing processes for display
  const formatProcesses = (processes) => {
    if (!processes || processes.length === 0) return "—";
    return processes.join(", ");
  };

  // Format materials for display
  const formatMaterials = (materials) => {
    if (!materials || materials.length === 0) return "—";
    return materials.join(", ");
  };

  return (
    <div>
      <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 mb-6">
        <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">
          REQUEST SUMMARY
        </p>
        <h3 className="text-xl font-extrabold text-gray-900 mb-5">
          {formData.projectName || "Untitled Project"}
        </h3>

        <div className="grid sm:grid-cols-2 gap-5">
          {/* Project Name */}
          <div>
            <p className="text-sm text-gray-500 mb-1">Project Name</p>
            <p className="font-semibold text-gray-900">{formData.projectName || "—"}</p>
          </div>

          {/* Quantity */}
          <div>
            <p className="text-sm text-gray-500 mb-1">Expected Quantity</p>
            <p className="font-semibold text-gray-900">{formData.requiredQuantity || "—"}</p>
          </div>

          {/* Product Category */}
          <div>
            <p className="text-sm text-gray-500 mb-1">Product Category</p>
            <p className="font-semibold text-gray-900">{formData.productCategory || formData.category || "—"}</p>
          </div>

          {/* Short Description */}
          <div>
            <p className="text-sm text-gray-500 mb-1">Short Description</p>
            <p className="font-semibold text-gray-900">{formData.shortDescription || "—"}</p>
          </div>

          {/* Detailed Description */}
          <div className="sm:col-span-2">
            <p className="text-sm text-gray-500 mb-1">Detailed Description</p>
            <p className="font-semibold text-gray-900">{formData.detailedProjectDescription || "—"}</p>
          </div>

          {/* Industry Sector */}
          <div>
            <p className="text-sm text-gray-500 mb-1">Industry Sector</p>
            <p className="font-semibold text-gray-900">{formData.industrySector || "—"}</p>
          </div>

          {/* Development Stage */}
          <div>
            <p className="text-sm text-gray-500 mb-1">Development Stage</p>
            <p className="font-semibold text-gray-900">{formData.developmentStage || "—"}</p>
          </div>

          {/* Budget Range */}
          <div>
            <p className="text-sm text-gray-500 mb-1">Budget Range</p>
            <p className="font-semibold text-gray-900">{formData.expectedBudgetRange || "—"}</p>
          </div>

          {/* Target Delivery */}
          <div>
            <p className="text-sm text-gray-500 mb-1">Target Delivery</p>
            <p className="font-semibold text-gray-900">{formData.targetDeliveryDate || "—"}</p>
          </div>

          {/* Location */}
          {/* <div>
            <p className="text-sm text-gray-500 mb-1">Preferred Location</p>
            <p className="font-semibold text-gray-900">{formData.preferredLocation || "—"}</p>
          </div> */}

          {/* Manufacturing Processes */}
          <div className="sm:col-span-2">
            <p className="text-sm text-gray-500 mb-1">Manufacturing Processes</p>
            <p className="font-semibold text-gray-900">
              {formatProcesses(formData.manufacturingProcesses || [formData.process])}
            </p>
          </div>

          {/* Required Materials */}
          <div className="sm:col-span-2">
            <p className="text-sm text-gray-500 mb-1">Required Materials</p>
            <p className="font-semibold text-gray-900">
              {formatMaterials(formData.requiredMaterials)}
            </p>
          </div>

          {/* Manufacturing Requirements */}
          <div className="sm:col-span-2">
            <p className="text-sm text-gray-500 mb-1">Manufacturing Requirements</p>
            <p className="font-semibold text-gray-900">{formData.manufacturingRequirements || "—"}</p>
          </div>

          {/* Files */}
          <div>
            <p className="text-sm text-gray-500 mb-1">Files Uploaded</p>
            <p className="font-semibold text-gray-900">
              {formData.enquiryFiles?.length || 0} file{formData.enquiryFiles?.length === 1 ? "" : "s"}
            </p>
          </div>

          {/* Status */}
          <div>
            <p className="text-sm text-gray-500 mb-1">Status</p>
            <p className="font-semibold text-green-600">Ready to Submit</p>
          </div>
        </div>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">
          {error}
        </div>
      )}

      <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-100">
        <button
          type="button"
          onClick={onBack}
          className="flex items-center gap-2 text-sm font-semibold px-5 py-2.5 rounded-xl border border-gray-200 text-gray-700 hover:bg-gray-50 transition"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Edit
        </button>
        <button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting}
          className="flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-500 text-white font-semibold px-6 py-2.5 rounded-xl hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? (
            <>
              <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Submitting...
            </>
          ) : (
            "Submit Prototype Request →"
          )}
        </button>
      </div>
    </div>
  );
}